import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { securityApi, type SecurityIncident } from '../../api/security';

export function IncidentCenterPage() {
  const [incidents, setIncidents] = useState<SecurityIncident[]>([]);
  useEffect(() => { void securityApi.incidents().then(setIncidents); }, []);
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Incident Center</h1>
      <Link to="/security" className="mt-2 inline-block text-sm text-indigo-700 hover:underline dark:text-indigo-400">← SOC Hub</Link>
      <div className="mt-6 space-y-3">{incidents.map((i) => (
        <div key={i.id} className="rounded-xl border p-4 dark:border-slate-700 dark:bg-slate-900">
          <div className="flex justify-between"><span className="font-medium">{i.title}</span><span className={`text-sm ${i.severity === 'critical' ? 'text-red-600' : 'text-amber-600'}`}>{i.severity}</span></div>
          <p className="mt-1 text-sm text-slate-500">{i.description}</p>
          <p className="mt-1 text-xs text-slate-500">Status: {i.status} · Risk: {i.risk_score}</p>
        </div>
      ))}{incidents.length === 0 && <p className="text-sm text-slate-500">No incidents. Simulate a high-risk threat to generate one.</p>}</div>
    </div>
  );
}
